/**
 * @fileoverview Venues List component.
 * @summary Displays list of venues with empty state.
 *
 * @package KaraoNow
 * @module apps/front/src/pages/organizer/components/VenuesList
 * @author Pierre-Yves Léglise <contact@axialdata.net>
 * @license EULA
 */
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faMapMarkerAlt, faPlus } from '@fortawesome/free-solid-svg-icons'
import { useTranslation } from 'react-i18next'
import { VenueCard } from './VenueCard'
import type { Venue } from '../../../store/slices/venuesSlice'
// import { useNavigate } from 'react-router-dom'

interface VenuesListProps {
  venues: Venue[]
  isDeleting: string | null
  onEdit: (venue: Venue) => void
  onDelete: (venue: Venue) => void
  onCreate: () => void
}

/**
 * @summary Venues list component.
 * @param {VenuesListProps} props - Component props.
 * @returns {React.ReactElement} Venues list.
 */
export function VenuesList({
  venues,
  isDeleting,
  onEdit,
  onDelete,
  onCreate,
}: VenuesListProps) {
  // const navigate = useNavigate()
  const { t } = useTranslation()

  return (
    <div className="card">
      <h2 className="text-xl font-semibold text-(--color-text-primary) ">
        {t('venues.venuesList')} ({venues.length})
      </h2>

      {venues.length === 0 ? (
        <div className="text-center pt-8 mb-4 text-(--color-text-secondary)">
          <FontAwesomeIcon icon={faMapMarkerAlt}  className="text-(--color-primary) text-4xl! w-16 h-16 mb-4 opacity-80" />
          <p className="text-lg font-medium mb-2">{t('venues.noVenues')}</p>
          <p className="text-sm">{t('venues.noVenuesDescription')}</p>
          <button className="btn btn-primary rounded-full! text-xl! text-bold! w-5! mt-4" onClick={onCreate}>
            <FontAwesomeIcon icon={faPlus} />
            </button>
        </div>
      ) : (
        <div className="space-y-3">
          {venues.map((venue) => (
            <VenueCard
              key={venue.id}
              venue={venue}
              isDeleting={isDeleting === venue.id}
              onEdit={onEdit}
              onDelete={onDelete}
            />
          ))}
        </div>
      )}
    </div>
  )
}

